<template>
  <div>
    <v-menu
      bottom
      left
      min-width="100"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          x-small
          icon
          outlined
          color="primary"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list
        dense
        class="pa-0"
      >
        <v-list-item @click="$emit('open', item)">
          <v-list-item-title>
            <v-icon
              small
              left
              color="success"
            >
              mdi-circle-edit-outline
            </v-icon>
            Edit
          </v-list-item-title>
        </v-list-item>
        <v-divider />
  
        <v-list-item
          v-if="!item.approved"
          @click="handleApprove(item)"
        >
          <v-list-item-title>
            <v-icon
              small
              left
              color="success"
            >
              mdi-check-decagram
            </v-icon>
            Mark Approve
          </v-list-item-title>
        </v-list-item>
        <v-divider />
        <v-list-item @click="stableItem(item)">
          <v-list-item-title>
            <v-icon
              small
              left
              color="primary"
            >
              mdi-check-circle-outline
            </v-icon>
            Toggle Stable
          </v-list-item-title>
        </v-list-item>
        <v-divider />
        <v-list-item @click="deprecatedItem(item)">
          <v-list-item-title>
            <v-icon
              small
              left
              color="orange"
            >
              mdi-alert
            </v-icon>
            Toggle Deprecated
          </v-list-item-title>
        </v-list-item>
        <v-divider />
        <v-list-item @click="ArchiveItem(item)">
          <v-list-item-title>
            <v-icon
              small
              left
              color="grey"
            >
              mdi-archive
            </v-icon>
            Archive
          </v-list-item-title>
        </v-list-item>
        <v-divider />
        <v-list-item @click="$emit('openView', item)">
          <v-list-item-title>
            <v-icon
              small
              left
              color="blue"
            >
              mdi-note
            </v-icon>
            Release Notes
          </v-list-item-title>
        </v-list-item>
        <v-divider />
      </v-list>
    </v-menu>
    <v-dialog
      v-model="notifyDialog"
      persistent
      max-width="350"
    >
      <v-toolbar
        dark
        color="error"
        dense
      >
        <v-toolbar-title class="white--text">
          Approve
        </v-toolbar-title>
      </v-toolbar>
      <v-card tile>
        <v-card-text
          class="pt-2"
          style="min-height:75px"
        >
          <v-checkbox
            v-model="notify"
            dense
          >
            <template v-slot:label>
              <span class="body-2">
                Do you want to notify all groups when this release is approved?
              </span>
            </template>
          </v-checkbox>
          Are you sure you want to approve this version
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="error"
            @click="closeNotifyDialog()"
          >
            No
          </v-btn>
          <v-btn
            color="success"
            @click="approveItem()"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> 
  </div>
</template>

<script>
import { failure } from "@/mixins/common";

export default {
  mixins: [failure],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data(){
    return{
      notifyDialog:false,
      notify:false,
      approvedId:0
    };
  },
  methods: {
    deleteItem(id) {
      this.$root.$confirm
        .open("Confirm", "Are you sure you want to delete?", {})
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.$http.delete(`${this.ADMIN_API_URL}/digitoryApps/${id}`).then(
            (data) => {
              this.$emit("refresh");
              this.handleSuccess(data.body);
            },
            (failure) => {
              this.handleFailure(failure);
            }
          );
        });
    },
    stableItem(item) {
      this.$root.$confirm
        .open("Confirm", "Are you sure you want to stable this version?", {})
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          let stableId = 1;
          if (item.stable) {
            stableId = 2;
          }

          let url = `${this.ADMIN_API_URL}/appReleases/toggleAppReleaseStable/${item.id}?stable=${stableId}`;

          this.$http
            .post(url)
            .then(
              (data) => {
                this.$emit("refresh");
                this.handleSuccess(data.body);
              },
              (failure) => {
                this.handleFailure(failure);
              }
            );
        });
    },
    deprecatedItem(item) {
      this.$root.$confirm
        .open("Confirm", "Are you sure you want to deprecate this version?", {})
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          let deprecatedId = 1;
          if (item.deprecated) {
            deprecatedId = 2;
          }
          this.$http
            .post(`${this.ADMIN_API_URL}/appReleases/toggleAppReleaseDeprecated/${item.id}?deprecated=${deprecatedId}`)
            .then(
              (data) => {
                this.$emit("refresh");
                this.handleSuccess(data.body);
              },
              (failure) => {
                this.handleFailure(failure);
              }
            );
        });
    },
    approveItem() {
         let notifyId = 1;
         if(!this.notify){
          notifyId = 2;
         }
          
            this.$http
            .post(`${this.ADMIN_API_URL}/appReleases/approve/${this.approvedId}?notify=${notifyId}`)
            .then(
              (data) => {
                this.$emit("refresh");
                this.closeNotifyDialog();
                this.handleSuccess(data.body);
              },
              (failure) => {
                this.closeNotifyDialog();
                this.handleFailure(failure);
              }
            );
            
          
    },
    handleApprove(item){
      this.notifyDialog = true;
      this.approvedId=item.id;
    },
    closeNotifyDialog(){
      this.notify = false;
      this.notifyDialog = false;
    },
    handleSuccess(response) {
      this.$store.commit("showSnackbar", {
        timeout: 3000,
        message: response.message
      });
    },
     ArchiveItem(item) {
      this.$root.$confirm
        .open("Confirm", "Are you sure you want to archive this version ?", {})
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          let archived = 1;
          if (item.archive) {
            archived = 2;
          }
          this.$http
            .post(`${this.ADMIN_API_URL}/appReleases/archive/${item.id}?archived=${archived}`)
            .then(
              (data) => {
                this.$emit("refresh");
                this.handleSuccess(data.body);
              },
              (failure) => {
                this.handleFailure(failure);
              }
            );
        });
    }
  }
};
</script>

<style></style>
